import columns from '../../../../../react-table/helpers/columns';
import { rowCount, sumRoundedTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NumberColumn,
    ExternalConsignmentLinkColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'cardit.consignmentId')),
        new DateTimeColumn('Completion date', 'cardit.completionDate'),
        new TextColumn('Final leg route', 'cardit.finalLegRoute'),
        new TextColumn('Final leg conveyance', 'cardit.finalLegConveyance'),
        new DateTimeColumn('Final leg planned departure', 'cardit.finalLegPlannedDepartureDate').withTotalHeader('Total'),
        new ExternalReceptacleLinkColumn(new NumberColumn('Receptacle ID', 'cardit.receptacleId').withTotalHeader(rowCount).withWidth(275)),
        new NumberColumn('Weight', 'cardit.weight').withTotalHeader(sumRoundedTotal),
      ],
    },
    {
      Header: 'RESDIT 14 last event',
      columns: [
        new DateTimeColumn('Any', 'resdit14LastEvent.any').withTotalHeader(rowCount),
        new DateTimeColumn('YHZ', 'resdit14LastEvent.yhz').withTotalHeader(rowCount),
      ],
    },
    {
      Header: 'RESDIT 42',
      columns: [
        new DateTimeColumn('YHZ', 'resdit42.yhz').withTotalHeader(rowCount),
      ],
    },
    {
      Header: 'RESDIT 21',
      columns: [
        new DateTimeColumn('YHZ', 'resdit21.yhz').withTotalHeader(rowCount),
        new DateTimeColumn('FSP', 'resdit21.fsp').withTotalHeader(rowCount),
        new DateTimeColumn('Last event', 'resdit21.lastEvent').withTotalHeader(rowCount),
        new TextColumn('Loc', 'resdit21.loc'),
      ],
    },
  ];
};
